import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { CanonicalTag } from "@/components/CanonicalTag";
import { secureLog } from "@/lib/security";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    secureLog.error(
      "404 Error: User attempted to access non-existent route:",
      { path: location.pathname }
    );
  }, [location.pathname]);

  return (
    <>
      <Helmet>
        <title>404 - Page Not Found | Sink Bike Run</title>
        <meta name="description" content="The page you're looking for doesn't exist. Return to Sink Bike Run to build your triathlon race day checklists." />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <CanonicalTag url="/" />
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="text-center">
          <h1 className="text-4xl font-display font-bold mb-4">404</h1>
          <p className="text-xl text-gray-600 font-body mb-4">Oops! Page not found</p>
          <Link to="/" className="text-blue-500 hover:text-blue-700 underline">
            Return to Home
          </Link>
        </div>
      </div>
    </>
  );
};

export default NotFound;
